
/* injects from baggage-loader */
require('./style.styl');

import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import Select from 'components/Select'

export default class TimeUnitSelector extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    timeUnit: PropTypes.string,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func
  }

  render() {
    const {label, timeUnit, disabled} = this.props

    return (
      <Fragment>
        <div className='time-unit-selector'>
          <div className='time-unit-selector_title'>{label}</div>
          <Select
            disabled={disabled}
            className='time-unit-selector_select'
            value={timeUnit}
            options={[
              {name: 'Hour', value: 'hour'},
              {name: 'Day', value: 'day'},
              {name: 'Week', value: 'week'},
              {name: 'Month', value: 'month'},
              {name: 'Year', value: 'year'}
            ]}
            onSelect={this.onTimeUnitSelect}
          />
        </div>
      </Fragment>
    )
  }
  onTimeUnitSelect = item => {
    const {onSelect} = this.props
    onSelect(item.value)
  }
}



// WEBPACK FOOTER //
// ./client/components/TimeUnitSelector/index.js